import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { ProjectSaleItem } from "@/models/project-sale-item.model"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useProjectsSaleItemsStore = defineStore("projectSaleItemsStore", () => {
  const projectsSaleItems: Ref<ProjectSaleItem[]> = ref([])

  const { getPriceAgreement, getUnitPrice } = usePriceAgreementsConstantTimeLookup<ProjectSaleItem>(
    projectsSaleItems,
    (item) => [item.project, item.saleItem],
    (item) => item.unitPrice
  )

  return {
    projectsSaleItems,
    getPriceAgreement,
    getUnitPrice
  }
})
